// Diagnostic snapshots only: never use client-reported values to resolve a prompt.
// Whitelist bounded scalar fields so manuscript text and character names cannot
// accidentally become invocation metadata.
export const diagnosticString = (value) => typeof value === "string" ? value.slice(0, 128) : null;
const diagnosticBoolean = (value) => typeof value === "boolean" ? value : null;

export function snapshotPovTenseSettings(settings) {
  return {
    povValue: diagnosticString(settings?.pov?.value),
    tenseValue: diagnosticString(settings?.tense?.value),
    povUserChanged: diagnosticBoolean(settings?.pov?.userChanged),
    tenseUserChanged: diagnosticBoolean(settings?.tense?.userChanged),
    povCharacterCount: Array.isArray(settings?.pov?.characters) ? settings.pov.characters.length : null,
  };
}

// Also called on receipt by the server: the browser payload is untrusted and
// optional (older web/mobile clients do not send it).
export function snapshotClientWritePovTense(state) {
  if (!state || typeof state !== "object") return null;
  const settings = (value) => ({
    povValue: diagnosticString(value?.povValue),
    tenseValue: diagnosticString(value?.tenseValue),
    povUserChanged: diagnosticBoolean(value?.povUserChanged),
    tenseUserChanged: diagnosticBoolean(value?.tenseUserChanged),
    povCharacterCount: Number.isSafeInteger(value?.povCharacterCount) && value.povCharacterCount >= 0
      ? value.povCharacterCount : null,
  });
  return {
    capturedAt: diagnosticString(state.capturedAt),
    documentId: diagnosticString(state.documentId),
    documentPovTenseId: diagnosticString(state.documentPovTenseId),
    documentSettingsStatus: diagnosticString(state.documentSettingsStatus),
    projectId: diagnosticString(state.projectId),
    isMultiplePOV: diagnosticBoolean(state.isMultiplePOV),
    saving: diagnosticBoolean(state.saving),
    project: settings(state.project),
    document: settings(state.document),
  };
}
